import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const IconDottedLineLg3 = ({ className }) => (
  <svg className={classNames('dotted-line-lg-3 d-none d-lg-block position-absolute', className)} width="232" height="76" viewBox="0 0 232 76" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 10.5L19.4634 15.6186C40.155 21.3548 62.2072 19.6053 81.7354 10.6781V10.6781C116.203 -5.07829 156.822 2.12661 183.768 28.776L230 74.5" stroke="#FDAE39" strokeWidth="4" strokeDasharray="2 2" />
  </svg>
);

IconDottedLineLg3.propTypes = {
  className: PropTypes.string,
};

IconDottedLineLg3.defaultProps = {
  className: '',
};
